<!-- <h4>
    LISTA DE SUCURSALES
</h4>
<div>
    <button class="btn btn-primary" (click)="setBranchOffice('oficina-principal')">Oficina Principal</button>
    <button class="btn btn-secondary" (click)="setBranchOffice('oficina-secundaria')">Oficina Secundaria</button>
</div> -->
<div class="container">
  <!-- <div class="box-design-bg"></div> -->
  <div class="col-lg-12 col-lg-12 col-md-12 col-sm-12 col-12 p-0">
    <div class="row justify-content-center">
      <div class="col-md-6">
        <div class="text-center">
          <h5><i class="fas fa-building m-r-5"></i>Bienvenid@ a tu empresa</h5>
          <p class="text-center m-b-0" *ngIf="company != null">
            <ng-container *ngIf="company.free_control">
              <span class="badge badge-info">PLAN GRATIS ILIMITADO</span>
            </ng-container>
            <ng-container *ngIf="!company.free_control">
                <ng-container *ngIf="activation != null">
                  <span class="badge badge-info f-s-12" *ngIf="activation.days_available >= 7">PLAN ACTUAL : Quedan {{activation.days_available}} días</span>
                  <span class="badge badge-warning f-s-12" *ngIf="activation.days_available < 7 && activation.days_available >= 1">PLAN ACTUAL : Quedan {{activation.days_available}} días</span>
                  <span class="badge badge-danger f-s-12 p-t-10 p-b-10" *ngIf="activation.days_available == 0">PLAN ACTUAL : Quedan {{activation.days_available}} días<br><br>(No podrá acceder al sistema mañana)</span>
                  <span class="badge badge-danger f-s-12 p-t-10 p-b-10" *ngIf="activation.days_available < 0">SU PLAN VENCIÓ HACE {{activation.days_available * (-1)}} días<br><br>( Consulte a soporte para activación +51 930 652 977 )</span>
                </ng-container>       
                <ng-container *ngIf="activation == null">
                  <span class="badge badge-info f-s-12 p-t-10 p-b-10">SOLICITA ACTIVACIÓN DEL PLAN <br><br>( Consulte a soporte para activación +51 930 652 977 )</span>
                </ng-container>             
            </ng-container>
          </p>
          <p class="text-muted">-------------------------------</p>
        </div>
      </div>
    </div>
    <div class="row m-t-10 p-l-50 p-r-50 justify-content-md-center content-sucursales">
      <div class="col-xl-4 col-lg-4 col-md-6 col-12 p-0" *ngFor="let item of branchoffices">
        <div class="card pricing-box mt-3">
          <div class="pricing-icon text-center">
            <ng-container *ngIf="company.url_image != null">
              <img id="output" src="tenants/{{company.url_image}}" style="height: 100px; width: 160px; border-radius: 8px;" />
            </ng-container>          
            <ng-container *ngIf="company.url_image == null">
              <i class="fas fa-store-alt bg-primary m-t-15"></i>
            </ng-container>       
          </div>
          <div class="pricing-content" *ngIf="company != null">
            <div class="pricing-features mt-4 p-l-0">
              <p class="mb-2 text-center bold f-s-16 text-uppercase" style="line-height: 1.2;">{{company.social_reason}}</p>
              <p class="mb-2 text-center bold f-s-16 text-uppercase">RUC: {{company.ruc}}</p>
              <p class="font-14 mb-2 text-center">
                <i class="fas fa-map-pin text-success mr-2"></i>
                {{company.address}}
              </p>   
            </div>
            <div class="pt-3 text-center">
              <ng-container *ngIf="company.free_control">
                <button class="btn btn-primary btn-round nowrap bold" (click)="setBranchOffice(item.slug)">INGRESAR A EMPRESA <i
                  class="fas fa-arrow-right m-l-5"></i>
                </button>
              </ng-container>
              <ng-container *ngIf="!company.free_control">
                <ng-container *ngIf="activation != null">
                  <ng-container *ngIf="activation.days_available >= 0">
                    <button class="btn btn-primary btn-round nowrap bold f-s-14" (click)="setBranchOffice(item.slug)">INGRESAR A EMPRESA <i
                      class="fas fa-arrow-right m-l-5"></i>
                    </button>
                  </ng-container>
                </ng-container>             
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

